/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { cartQuestionDuocolorStatic } from "../assets/cart-question-duocolor-static";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconCartQuestionDuocolorStatic = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={cartQuestionDuocolorStatic.svg} />
);

IllustrativeIconCartQuestionDuocolorStatic.displayName = "IllustrativeIconCartQuestionDuocolorStatic";
